import AddLms from '../../features/addlms/AddLms'

const AddLmsPage = () => {
    return (
        <AddLms />
    )
}

export default AddLmsPage
